import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

export const CnapSearch = ({ initial = "", large = false }) => {
  const [v, setV] = useState(initial);
  const [err, setErr] = useState("");
  const nav = useNavigate();

  const submit = (e) => {
    e.preventDefault();
    const q = v.trim();
    if (/^\d+$/.test(q) && q.length !== 8) return setErr("Le numéro CNAP doit contenir exactement 8 chiffres.");
    if (q.length < 2) return setErr("Saisissez un numéro CNAP (8 chiffres) ou au moins 2 lettres du nom.");
    setErr("");
    nav(`/verification?q=${encodeURIComponent(q)}`);
  };

  return (
    <form onSubmit={submit} data-testid="cnap-search-form" className="w-full">
      <div className={`flex items-center gap-2 bg-white rounded-full border border-emerald-900/15 shadow-[0_10px_40px_-15px_rgba(6,78,59,0.35)] focus-within:ring-4 focus-within:ring-emerald-500/20 transition-shadow ${large ? "p-2" : "p-1.5"}`}>
        <Search className="ml-3 h-5 w-5 text-emerald-700 shrink-0" />
        <input
          data-testid="cnap-search-input"
          maxLength={80}
          value={v}
          onChange={(e) => setV(e.target.value)}
          placeholder="N° CNAP ou nom de l'AP"
          className={`flex-1 min-w-0 bg-transparent outline-none text-slate-900 placeholder:text-slate-400 ${large ? "text-lg py-2" : "text-base py-1.5"}`}
        />
        <button type="submit" data-testid="cnap-search-submit" className={`rounded-full bg-emerald-700 hover:bg-emerald-800 active:scale-[0.97] text-white font-semibold transition-[background-color,transform] ${large ? "px-6 py-3" : "px-5 py-2"}`}>
          Vérifier
        </button>
      </div>
      {err && <p data-testid="cnap-search-error" className="mt-2 ml-4 text-sm text-rose-600">{err}</p>}
    </form>
  );
};
